<template>
  <div class="searchable-service-list">
    <div class="header">
      <el-input
        prefix-icon="el-icon-search"
        class="query-input"
        :value="query"
        @input="handleChangeQuery"
        placeholder="ค้นหาบริการ/ผู้ให้บริการ"
        clearable
      ></el-input>
      <sc-button
          class="add-all-button"
          v-if="showAddAllButton"
          @click="handleClickAddAllButton"
          >{{addAllButtonText}}</sc-button
        >
    </div>
    <div class="list-body">
      <div class="empty" v-if="noResult">{{ emptyText }}</div>
      <service-selector-option
        class="selected-item"
        v-for="item in selectableServices"
        :key="item.id"
        v-bind="item"
        :canSelect="canSelect"
        @select="handleSelectService(item)"
      ></service-selector-option>
      <infinite-loading
        @infinite="infiniteHandler"
        spinner="spiral"
        ref="infiniteLoading"
      >
        <span slot="no-results" />
        <span slot="no-more" />
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui";
import ServiceSelectorOption from "./ServiceSelectorOption";
import SelectedServiceList from "./SelectedServiceList";
import ScButton from "@/lib/components/ScButton";
import InfiniteLoading from "vue-infinite-loading";
import { nextTick } from 'vuedraggable';

export default {
  components: {
    ServiceSelectorOption,
    "el-input": Input,
    SelectedServiceList,
    ScButton,
    InfiniteLoading
  },
  props: ["query", "isLoading", "value", "disabled", "hasMoreServices", "showAddAll"],
  data() {
    return {};
  },
  computed: {
    selectableServices() {
      return this.value;
    },
    canSelect() {
      return !this.disabled;
    },
    noResult() {
      return this.value.length === 0;
    },
    isEmpty() {
      return this.value.length === 0;
    },
    emptyText() {
      if (this.isEmpty) {
        return "ไม่มีบริการ";
      }

      return "ไม่พบบริการที่ค้นหา";
    },
    showAddAllButton() {
      return this.showAddAll;
    },
    addAllButtonText() {
      if (this.query !== '') {
        return 'เพิ่มผลsearchทั้งหมด'
      } else {
        return 'เพิ่มทั้งหมด'
      }
    }
  },
  methods: {
    handleClickAddAllButton(service) {
      this.$emit("addAll");
    },
    handleSelectService(service) {
      this.$emit("select", service);
    },
    handleChangeQuery(value) {
      this.$emit("queryChange", value);
    },
    infiniteHandler($state) {
      setTimeout(() => {
        if (this.hasMoreServices) {
          this.$emit("getMoreServices");
          $state.loaded();
        } else {
          $state.complete();
        }
      }, 1000);
    },
    resetLoading() {
      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.searchable-service-list {
  position: relative;

  border: $border;
  border-radius: $border-radius;

  .el-input__inner {
    border: 0;
    border-bottom: $border;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;

    height: 43px;
    line-height: 43px;
  }

  > .list-body {
    overflow-y: auto;
    height: 500px;
  }

  > .list-body > .empty {
    padding: 20px 0;
    text-align: center;
  }

  .loading-indicator {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 43px;

    border-bottom-right-radius: $border-radius;

    background: rgba(255, 255, 255, 0.7);

    text-align: center;
    padding: $space;

    &.active {
      display: block;
    }
  }
}

.header {
  display: grid;
  grid-template-columns: 1fr auto;

  > .add-all-button {
    height: 43px;
    font-size: 0.8rem;
    color: #444;
    border: 0;
    border-radius: 0;
    border-top-right-radius: $border-radius;
    border-left: $border;
    border-bottom: $border;

    &:hover,
    &:focus {
      border-color: #dcdfe6 !important;
    }
  }
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid $primary-color;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: $primary-color transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/ServiceSelector/SearchableServiceList.vue